/**
 * 获取URL中的查询参数的值
 * @method  SC.util.getUrlParam
 * @param {string} paras 参数key
 * @returns {string} 返回参数的value
 */
export const getUrlParam = (paras) => {
  const url = location.href.split('#')[0];
  const paraString = url.substring(url.indexOf('?') + 1, url.length).split('&');
  const paraObj = {};
  let j;
  // eslint-disable-next-line no-cond-assign
  for (let i = 0; (j = paraString[i]); i++) {
    paraObj[j.substring(0, j.indexOf('=')).toLowerCase()] = j.substring(
      j.indexOf('=') + 1,
      j.length
    );
  }
  const returnValue = paraObj[paras.toLowerCase()];
  if (typeof returnValue === 'undefined') {
    return '';
  }
  return returnValue;
};

/**
 * 获取一个设置查询参数的url
 * @param {*} url
 * @param {*} arg
 * @param {*} arg_val
 * @returns
 */
export const getUrlWithParam = (url, arg, arg_val) => {
  const pattern = `${arg}=([^&]*)`;
  const replaceText = `${arg}=${arg_val}`;
  if (url.match(pattern)) {
    let tmp = `/(${arg}=)([^&]*)/gi`;
    // eslint-disable-next-line no-eval
    tmp = url.replace(eval(tmp), replaceText);
    return tmp;
  }

  return url.match('[?]') ? `${url}&${replaceText}` : `${url}?${replaceText}`;
};

/**
 * 获取不带参数的 url
 */
export const getOnlyPathUrl = () => {
  const { origin, pathname } = location;
  return `${origin}${pathname}`;
};
